import { render } from "./TheScheduleServicePoint.vue?vue&type=template&id=6e8de459"
import script from "./TheScheduleServicePoint.vue?vue&type=script&lang=js"
export * from "./TheScheduleServicePoint.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__